/*
 * ============================================
 * 🔧 CUSTOM CODE - DO NOT REMOVE
 * ============================================
 * Feature: Kersthanger configurator met uitgesneden naam
 * Hoort bij: snippets/custom-kersthanger.liquid (+ custom-kersthanger-stijl.liquid), assets/custom-kersthanger.css,
 *            blokken 'kersthanger' en 'kersthanger_stijl' in sections/main-product.liquid, templates/product.kersthanger.json
 * Datum: 2026-10-16 (Frank: de klant ziet vaste voorbeeldafbeeldingen; Emmy past het snijbestand zo nodig aan);
 *        2026-10-20 productiemodus en _Ontwerp eruit: het snijbestand komt alleen nog uit de kersthanger-dienst (_Hanger),
 *        zodat de ontwerpen, het lettertype en de rekenkern niet openbaar in het thema staan
 *
 * Web Component <kersthanger-configurator>:
 * - de klant kiest een ontwerp (tegels) en typt een naam; het voorbeeld is de vaste afbeelding van het ontwerp
 *   (foto of afbeelding die wij maken), niet de naam van de klant; de maat staat eronder (data-maat van de tegel);
 * - controle: alleen tekens die het lettertype heeft, maximaal 15; een naam helemaal in hoofdletters (EMMA) wordt Emma;
 * - Tekst en Stijl (Nederlandse ontwerpnaam) gaan als line item properties mee; met de blokinstelling productie_url
 *   ook _Hanger (verborgen): <productie_url>/hanger/<willekeurige id>, de pagina van de kersthanger-dienst in Azure
 *   (repo blf-gepersonaliseerde-kersthanger) waar Emmy het snijbestand downloadt en de naam zo nodig bijstelt;
 *   of de naam goed in de hanger past, rekent de website niet voor de klant uit: de bestelling gaat altijd door;
 * - validatie in de capture-fase van submit, omdat het Dawn formulier 'novalidate' is;
 * - na het toevoegen (pubsub cartUpdate van dit formulier) wordt het tekstveld leeg en blijft het ontwerp staan.
 * ============================================
 */
if (!customElements.get('kersthanger-configurator')) {
  /* Onzichtbare tekens die een emoji-toetsenbord of plakken meestuurt */
  const KERSTHANGER_ONZICHTBAAR = /[︎️​-‍⁠﻿]/g;
  /* Lookalikes van autocorrectie of plakken: liggende streepjes worden '-', schuine apostrofs worden ' */
  const KERSTHANGER_STREEPJES = /[‐-―−]/g;
  const KERSTHANGER_APOSTROFS = /[´`ʼ‘’]/g;
  /* Willekeurige id (UUID v4) voor de property _Hanger */
  const kersthangerUuid = () => {
    if (typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    const b = window.crypto.getRandomValues(new Uint8Array(16));
    b[6] = (b[6] & 0x0f) | 0x40;
    b[8] = (b[8] & 0x3f) | 0x80;
    const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
    return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
  };
  /* De tekens die het lettertype (Kersthanger Script Bold) heeft, naast de spatie. Gemaakt uit het lettertype
     (ontwikkel/bron/lettertype/tekens.txt in de repo blf-gepersonaliseerde-kersthanger); bij een ander lettertype opnieuw maken. */
  const KERSTHANGER_TEKENS = '!&\u0027-.0123456789?ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz\u00C0\u00C1\u00C2\u00C3\u00C4\u00C5\u00C6\u00C7\u00C8\u00C9\u00CA\u00CB\u00CC\u00CD\u00CE\u00CF\u00D0\u00D1\u00D2\u00D3\u00D4\u00D5\u00D6\u00D8\u00D9\u00DA\u00DB\u00DC\u00DD\u00DE\u00DF\u00E0\u00E1\u00E2\u00E3\u00E4\u00E5\u00E6\u00E7\u00E8\u00E9\u00EA\u00EB\u00EC\u00ED\u00EE\u00EF\u00F0\u00F1\u00F2\u00F3\u00F4\u00F5\u00F6\u00F8\u00F9\u00FA\u00FB\u00FC\u00FD\u00FE\u00FF\u0100\u0101\u0102\u0103\u0104\u0105\u0106\u0107\u0108\u0109\u010A\u010B\u010C\u010D\u010E\u010F\u0110\u0111\u0112\u0113\u0114\u0115\u0116\u0117\u0118\u0119\u011A\u011B\u011C\u011D\u011E\u011F\u0120\u0121\u0122\u0123\u0124\u0125\u0126\u0127\u0128\u0129\u012A\u012B\u012C\u012D\u012E\u012F\u0130\u0131\u0132\u0133\u0134\u0135\u0136\u0137\u0138\u0139\u013A\u013B\u013C\u013D\u013E\u013F\u0140\u0141\u0142\u0143\u0144\u0145\u0146\u0147\u0148\u0149\u014A\u014B\u014C\u014D\u014E\u014F\u0150\u0151\u0152\u0153\u0154\u0155\u0156\u0157\u0158\u0159\u015A\u015B\u015C\u015D\u015E\u015F\u0160\u0161\u0162\u0163\u0164\u0165\u0166\u0167\u0168\u0169\u016A\u016B\u016C\u016D\u016E\u016F\u0170\u0171\u0172\u0173\u0174\u0175\u0176\u0177\u0178\u0179\u017A\u017B\u017C\u017D\u017E\u018F\u0192\u01A0\u01A1\u01AF\u01B0\u01C4\u01C5\u01C6\u01C7\u01C8\u01C9\u01CA\u01CB\u01CC\u01E6\u01E7\u01EA\u01EB\u01FA\u01FB\u01FC\u01FD\u01FE\u01FF\u0200\u0201\u0202\u0203\u0204\u0205\u0206\u0207\u0208\u0209\u020A\u020B\u020C\u020D\u020E\u020F\u0210\u0211\u0212\u0213\u0214\u0215\u0216\u0217\u0218\u0219\u021A\u021B\u022A\u022B\u022C\u022D\u0230\u0231\u0232\u0233\u0237';
  const KERSTHANGER_LEESTEKENS = "& ' . ! ? -";
  const KERSTHANGER_TOEGESTAAN = (teken) => teken === ' ' || KERSTHANGER_TEKENS.includes(teken);

  /* EMMA -> Emma, ANNE-SOPHIE -> Anne-Sophie, IJSBRAND -> IJsbrand, O'NEILL -> O'Neill. Alleen voor tekst die
     helemaal in hoofdletters staat (minstens twee letters): gemengde invoer blijft zoals de klant hem typt. */
  const kersthangerHoofdletterWoorden = (tekst) => {
    const letters = Array.from(tekst).filter((teken) => teken.toLowerCase() !== teken.toUpperCase());
    if (letters.length < 2 || letters.some((teken) => teken !== teken.toUpperCase())) return tekst;
    return tekst
      .toLowerCase()
      .replace(/(^|[\s-])(ij|.)/g, (_, voor, letter) => voor + letter.toUpperCase())
      .replace(/(^|[\s-])(\S)'(\S)/g, (_, voor, eerste, volgende) => `${voor}${eerste}'${volgende.toUpperCase()}`);
  };

  customElements.define(
    'kersthanger-configurator',
    class KersthangerConfigurator extends HTMLElement {
      constructor() {
        super();
        this.accentWacht = false; // een dode toets (¨ ´ ` ^ ~) wacht nog op zijn letter
        this.productFormErrorShown = false;
        this.hangerIds = new Map(); // ontwerp + naam -> id voor _Hanger
        this.onSubmit = this.onSubmit.bind(this);
        this.onPageShow = this.onPageShow.bind(this);
        this.onPaymentButtonClick = this.onPaymentButtonClick.bind(this);
      }

      connectedCallback() {
        this.productInfo = this.closest('product-info');
        this.form = this.resolveForm();
        /* getAttribute: het formulier bevat een input name="id", waardoor form.id dat element teruggeeft i.p.v. de id-string */
        this.formId = this.form ? this.form.getAttribute('id') : this.dataset.formId;
        this.productForm = this.form ? this.form.closest('product-form') : null;

        this.beeld = this.querySelector('[data-kersthanger-beeld]');
        this.afbeelding = this.querySelector('.kersthanger__afbeelding');
        this.maatElement = this.querySelector('[data-kersthanger-maat]');
        this.input = this.querySelector('[data-kersthanger-input]');
        this.counter = this.querySelector('[data-kersthanger-counter]');
        this.errorElement = this.querySelector('[data-kersthanger-error]');
        this.addedElement = this.querySelector('[data-kersthanger-added]');
        this.propertiesContainer = this.querySelector('[data-kersthanger-properties]');
        this.dienst = this.leesDienst(this.dataset.dienstUrl);
        if (!this.dienst) console.warn('[kersthanger] Geen adres van de kersthanger-dienst (blokinstelling productie_url): bestellingen krijgen geen _Hanger');
        this.styleItems = Array.from(this.querySelectorAll('[data-kersthanger-style-input]')).map((input) => {
          const label = input.closest('[data-kersthanger-style]');
          return {
            stijl: input.value,
            input,
            label,
            naamNl: label?.dataset.naamNl || input.value,
            naamLokaal: (label?.querySelector('.kersthanger__style-name')?.textContent || input.value).trim(),
            maat: label?.dataset.maat || '',
            afbeelding: label?.dataset.afbeelding || '',
          };
        });
        if (!this.input || !this.beeld || !this.propertiesContainer || !this.styleItems.length) return;

        this.strings = this.readStrings();
        this.maxTekens = parseInt(this.dataset.maxTekens, 10) || 15;
        if (!this.styleItems.some((item) => item.input.checked)) this.styleItems[0].input.checked = true;

        /* Alleen wachten zolang een dode toets (" + e = ë) op zijn letter wacht, nooit een heel woord: Android-
           toetsenborden (Gboard, SwiftKey) stellen hele woorden samen. Zelfde aanpak als in custom-naamletters.js. */
        this.input.addEventListener('input', () => {
          if (this.accentWacht) return;
          this.onInvoer();
        });
        this.input.addEventListener('compositionupdate', (event) => {
          this.accentWacht = /^[\p{Sk}\p{M}'"~]+$/u.test(event.data || '');
        });
        this.input.addEventListener('compositionend', () => {
          this.accentWacht = false;
          this.onInvoer();
        });
        this.styleItems.forEach((item) => item.input.addEventListener('change', () => this.render()));
        /* Thema-editor: een stijlblok aanklikken kiest dat ontwerp in het voorbeeld */
        this.addEventListener('shopify:block:select', (event) => {
          const label = event.target.closest ? event.target.closest('[data-kersthanger-style]') : null;
          const item = label ? this.styleItems.find((entry) => entry.label === label) : null;
          if (!item) return;
          item.input.checked = true;
          this.render();
        });
        (this.productInfo || this.form)?.addEventListener('submit', this.onSubmit, true);
        /* "Direct kopen"-knoppen (dynamic checkout) omzeilen het submit-event; ook die tegenhouden zonder geldige naam */
        (this.productInfo || this.form)?.addEventListener('click', this.onPaymentButtonClick, true);
        /* Na toevoegen aan de winkelwagen (Dawn pubsub): veld leeg voor de volgende naam, ontwerp blijft staan */
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.onCartUpdate(event));
        }
        window.addEventListener('pageshow', this.onPageShow);
        this.render();
      }

      disconnectedCallback() {
        clearTimeout(this.renderTimer);
        (this.productInfo || this.form)?.removeEventListener('submit', this.onSubmit, true);
        (this.productInfo || this.form)?.removeEventListener('click', this.onPaymentButtonClick, true);
        if (typeof this.cartUpdateUnsubscriber === 'function') this.cartUpdateUnsubscriber();
        this.cartUpdateUnsubscriber = null;
        window.removeEventListener('pageshow', this.onPageShow);
      }

      /* Terug op deze pagina uit de browsercache (bijvoorbeeld met Terug na een bestelling): nieuwe ids, zodat een
         tweede bestelling met dezelfde naam een eigen hanger in de dienst wordt */
      onPageShow(event) {
        if (!event || !event.persisted) return;
        this.hangerIds.clear();
        this.render();
      }

      /* ---------- initialisatie ---------- */

      resolveForm() {
        const byId = this.dataset.formId ? document.getElementById(this.dataset.formId) : null;
        if (byId && (!this.productInfo || this.productInfo.contains(byId))) return byId;
        return this.productInfo ? this.productInfo.querySelector('form[data-type="add-to-cart-form"]') : byId;
      }

      /* Vertaalde teksten uit de snippet (locales kersthanger.*); [naam] wordt hier ingevuld */
      readStrings() {
        const script = this.querySelector('[data-kersthanger-strings]');
        if (!script) return {};
        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('[kersthanger] Teksten konden niet gelezen worden', error);
          return {};
        }
      }

      text(key, values = {}) {
        return Object.entries(values).reduce(
          (result, [name, value]) => result.split(`[${name}]`).join(String(value)),
          this.strings[key] || ''
        );
      }

      /* ---------- invoer ---------- */

      gekozen() {
        return this.styleItems.find((item) => item.input.checked) || this.styleItems[0];
      }

      /* De naam zoals hij gesneden wordt: opgeschoond, en EMMA wordt Emma */
      tekst() {
        const ruw = (this.input.value || '')
          .normalize('NFC')
          .replace(KERSTHANGER_ONZICHTBAAR, '')
          .replace(KERSTHANGER_STREEPJES, '-')
          .replace(KERSTHANGER_APOSTROFS, "'")
          .replace(/\s+/g, ' ')
          .trim();
        return kersthangerHoofdletterWoorden(ruw);
      }

      /* null als de naam besteld kan worden, anders { fout, tekens } */
      controleer(tekst) {
        if (!tekst) return { fout: 'leeg' };
        const tekens = Array.from(tekst);
        const ongeldig = Array.from(new Set(tekens.filter((teken) => !KERSTHANGER_TOEGESTAAN(teken))));
        if (ongeldig.length) return { fout: 'ongeldig', tekens: ongeldig };
        if (tekens.length > this.maxTekens) return { fout: 'te-lang' };
        return null;
      }

      foutTekst(controle) {
        switch (controle.fout) {
          case 'leeg':
            return this.text('errorEmpty');
          case 'te-lang':
            return this.text('errorTooLong', { max: this.maxTekens });
          default:
            /* De toegestane leestekens komen uit de JS: zo hoeft er geen & of ' in de vertaling (Liquid zou die escapen) */
            return this.text('errorInvalid', { characters: controle.tekens.join(' '), symbols: KERSTHANGER_LEESTEKENS });
        }
      }

      onInvoer() {
        if (this.addedElement) this.addedElement.hidden = true;
        clearTimeout(this.renderTimer);
        this.renderTimer = setTimeout(() => {
          if (!this.accentWacht) this.render();
        }, 30);
      }

      /* ---------- weergave (klant) ---------- */

      render() {
        clearTimeout(this.renderTimer);
        const item = this.gekozen();
        const tekst = this.tekst();
        const controle = this.controleer(tekst);

        this.styleItems.forEach((entry) => entry.label?.classList.toggle('is-selected', entry === item));
        if (this.maatElement) this.maatElement.textContent = item.maat || ' ';
        if (this.afbeelding && item.afbeelding && this.afbeelding.getAttribute('src') !== item.afbeelding) {
          /* srcset/sizes van image_tag weghalen, anders kiest de browser de oude afbeelding */
          this.afbeelding.removeAttribute('srcset');
          this.afbeelding.removeAttribute('sizes');
          this.afbeelding.src = item.afbeelding;
        }
        if (this.afbeelding) this.afbeelding.alt = this.text('previewAlt', { style: item.naamLokaal });

        const aantal = Array.from(tekst).length;
        if (this.counter) {
          this.counter.textContent = this.text('counter', { current: aantal, max: this.maxTekens });
          this.counter.classList.toggle('is-te-veel', aantal > this.maxTekens);
        }
        /* Tijdens het typen alleen echte fouten tonen; 'leeg' pas bij het bestellen */
        if (controle && controle.fout !== 'leeg') this.showError(this.foutTekst(controle));
        else this.hideError();
        this.renderProperties(controle ? null : tekst, item);
      }

      showError(message, viaFormulier = false) {
        if (this.errorElement) {
          this.errorElement.textContent = message;
          this.errorElement.hidden = false;
        }
        if (viaFormulier && this.productForm && typeof this.productForm.handleErrorMessage === 'function') {
          this.productForm.handleErrorMessage(message);
          this.productFormErrorShown = true;
        }
      }

      hideError() {
        if (this.errorElement) {
          this.errorElement.hidden = true;
          this.errorElement.textContent = '';
        }
        if (this.productFormErrorShown && this.productForm && typeof this.productForm.handleErrorMessage === 'function') {
          this.productForm.handleErrorMessage();
          this.productFormErrorShown = false;
        }
      }

      /* ---------- properties ---------- */

      /* Adres van de kersthanger-dienst (blokinstelling productie_url): alleen https, alleen schema en host */
      leesDienst(waarde) {
        try {
          const url = new URL(String(waarde || '').trim());
          return url.protocol === 'https:' ? url.origin : '';
        } catch (e) {
          return '';
        }
      }

      /* Eén id per ontwerp en naam: dezelfde hanger nog eens toevoegen wordt dezelfde regel (aantal 2), een andere
         naam of een ander ontwerp krijgt een eigen id en dus een eigen pagina in de dienst. */
      hangerId(tekst, stijl) {
        const sleutel = `${stijl}|${tekst}`;
        if (!this.hangerIds.has(sleutel)) this.hangerIds.set(sleutel, kersthangerUuid());
        return this.hangerIds.get(sleutel);
      }

      renderProperties(tekst, item) {
        this.propertiesContainer.innerHTML = '';
        if (!tekst) return;
        const addProperty = (key, value) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${key}]`;
          input.value = value;
          input.setAttribute('form', this.formId);
          this.propertiesContainer.appendChild(input);
        };
        addProperty('Tekst', tekst);
        addProperty('Stijl', item.naamNl);
        if (this.dienst) addProperty('_Hanger', `${this.dienst}/hanger/${this.hangerId(tekst, item.stijl)}`);
      }

      /* ---------- bestellen ---------- */

      validate() {
        /* Altijd opnieuw voor de tekst van dit moment (er kan nog een weergave gepland staan) */
        this.render();
        const controle = this.controleer(this.tekst());
        if (controle) return this.foutTekst(controle);
        if (!this.propertiesContainer.querySelector('input')) return this.text('errorEmpty');
        return null;
      }

      onSubmit(event) {
        if (this.form && event.target !== this.form) return;
        const error = this.validate();
        if (!error) {
          this.hideError();
          return;
        }
        event.preventDefault();
        event.stopPropagation();
        this.showError(error, true);
        this.input.focus();
      }

      onPaymentButtonClick(event) {
        if (!event.target.closest || !event.target.closest('.shopify-payment-button')) return;
        const error = this.validate();
        if (!error) return;
        event.preventDefault();
        event.stopPropagation();
        this.showError(error, true);
      }

      onCartUpdate(event) {
        if (!event || event.source !== 'product-form') return;
        /* Alleen als dit formulier toevoegde (niet een snelle toevoeging van een ander product op de pagina) */
        const variantInput = this.form ? this.form.querySelector('input[name="id"]') : null;
        if (variantInput && event.productVariantId != null && String(event.productVariantId) !== String(variantInput.value)) {
          return;
        }
        this.input.value = '';
        this.hideError();
        this.render();
        if (this.addedElement) {
          this.addedElement.textContent = this.text('added');
          this.addedElement.hidden = false;
        }
      }
    }
  );
}
